import React, { useEffect, createContext, useState } from "react";
import {
  Switch,
  Route,
  BrowserRouter,
  useHistory,
  useLocation,
} from "react-router-dom";
import "./App.scss";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import Home from "./pages/Home";
import { Modal } from "antd";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";

const ReachableContext = createContext(null);
const config = {
  title: "Token không hợp lệ!",
  maskClosable: false,
  footer: null,
  content: (
    <>
      <ReachableContext.Consumer>
        {(name) => `Có lỗi xảy ra vui lòng trở về trang chủ`}
      </ReachableContext.Consumer>
    </>
  ),
};

const App = () => {
  const [modal, contextHolder] = Modal.useModal();
  const queryParams = new URLSearchParams(window.location.search);
  const verifyTokenRaw =
    queryParams.get("VerifyToken") || queryParams.get("verifyToken") || queryParams.get("loginToken");
  let verifyToken = verifyTokenRaw?.replace(/ /g, "+");
  const [token, setToken] = useState(
    verifyToken ? null : localStorage.getItem("hotelToken")
  );
  const [ready, setReady] = useState(false);

  const decodeToken = async () => {
    // Lấy token từ URL
    try {
      if (verifyToken) {
        localStorage.removeItem("hotelToken");
        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/v1/auth/login-hlbank`,
          {
            VerifyToken: verifyToken,
            TypeService: "hotel",
          },
        );
        const accesstoken = res.data.data.accesstoken;
        localStorage.setItem("hotelToken", accesstoken);
        setToken(accesstoken);
        const userInfo = res?.data?.data?.userinfo;
        if (userInfo) {
          userInfo.phone = userInfo?.phone?.replace(/^84/, "0");
          sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
        }
      } else {
        modal.error(config);
      }
    } catch (error) { } finally {
      setReady(true);
    }
  };

  useEffect(() => {
    decodeToken();
  }, []);

  return (
    <>
      {ready ? (
        <Switch>
          {/* <Redirect exact from="/" to={accessToken ? "/dashboard/home" : "/login"} /> */}
          {/* <RouteUnauthenticated path="/login" component={Login} /> */}
          {/* <RouteAuthenticated path="/dashboard/home" component={Home} /> */}
          <Redirect exact from="/" to={"/booking-hotel"} />
          <Route
            exact
            path={"/booking-hotel"}
            render={(props) => <Home {...props} token={token} />}
          />
          <Route
            exact
            path={"/history"}
            render={(props) => <Home {...props} token={token} />}
          />
          <Redirect to={"/booking-hotel"} />
        </Switch>
      ) : null}
      {contextHolder}
    </>
  );
};

// const RouteAuthenticated = ({ component: Component, path }) => {1
//  const accessToken = Cookies.get("accessToken");
//   if (!accessToken) {
//     return <Redirect to="/login" />;
//   }
//   return (
//     <LayoutClient>
//       <Route exact component={Component} path={path} />
//     </LayoutClient>
//   )
// };

const RouteUnauthenticated = ({ component: Component, path }) => {
  // const accessToken = Cookies.get("accessToken");
  // if (accessToken) {
  //   return <Redirect to="/dashboard/home" />;
  // }

  return <Route exact component={Component} path={path} />;
};

export default App;
